function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import LineString from '../LineString';
import Point from '../Point';
import Polygon from '../Polygon';
import MultiPoint from '../MultiPoint';
import LinearRing from '../LinearRing';
import MultiPolygon from '../MultiPolygon';
import GeometryCollection from '../GeometryCollection';
import ArrayList from '../../../../../java/util/ArrayList';
import Assert from '../../util/Assert';
import MultiLineString from '../MultiLineString';
var GeometryEditor = /*#__PURE__*/function () {
  function GeometryEditor() {
    _classCallCheck(this, GeometryEditor);
    GeometryEditor.constructor_.apply(this, arguments);
  }
  return _createClass(GeometryEditor, [{
    key: "setCopyUserData",
    value: function setCopyUserData(isUserDataCopied) {
      this._isUserDataCopied = isUserDataCopied;
    }
  }, {
    key: "edit",
    value: function edit(geometry, operation) {
      if (geometry === null) return null;
      var result = this.editInternal(geometry, operation);
      if (this._isUserDataCopied) {
        result.setUserData(geometry.getUserData());
      }
      return result;
    }
  }, {
    key: "editInternal",
    value: function editInternal(geometry, operation) {
      if (this._factory === null) this._factory = geometry.getFactory();
      if (geometry instanceof GeometryCollection) {
        return this.editGeometryCollection(geometry, operation);
      }
      if (geometry instanceof Polygon) {
        return this.editPolygon(geometry, operation);
      }
      if (geometry instanceof Point) {
        return operation.edit(geometry, this._factory);
      }
      if (geometry instanceof LineString) {
        return operation.edit(geometry, this._factory);
      }
      Assert.shouldNeverReachHere('Unsupported Geometry class: ' + geometry.getClass().getName());
      return null;
    }
  }, {
    key: "editGeometryCollection",
    value: function editGeometryCollection(collection, operation) {
      var collectionForType = operation.edit(collection, this._factory);
      var geometries = new ArrayList();
      for (var i = 0; i < collectionForType.getNumGeometries(); i++) {
        var geometry = this.edit(collectionForType.getGeometryN(i), operation);
        if (geometry === null || geometry.isEmpty()) {
          continue;
        }
        geometries.add(geometry);
      }
      if (collectionForType.getClass() === MultiPoint) {
        return this._factory.createMultiPoint(geometries.toArray([]));
      }
      if (collectionForType.getClass() === MultiLineString) {
        return this._factory.createMultiLineString(geometries.toArray([]));
      }
      if (collectionForType.getClass() === MultiPolygon) {
        return this._factory.createMultiPolygon(geometries.toArray([]));
      }
      return this._factory.createGeometryCollection(geometries.toArray([]));
    }
  }, {
    key: "editPolygon",
    value: function editPolygon(polygon, operation) {
      var newPolygon = operation.edit(polygon, this._factory);
      if (newPolygon === null) newPolygon = this._factory.createPolygon();
      if (newPolygon.isEmpty()) {
        return newPolygon;
      }
      var shell = this.edit(newPolygon.getExteriorRing(), operation);
      if (shell === null || shell.isEmpty()) {
        return this._factory.createPolygon();
      }
      var holes = new ArrayList();
      for (var i = 0; i < newPolygon.getNumInteriorRing(); i++) {
        var hole = this.edit(newPolygon.getInteriorRingN(i), operation);
        if (hole === null || hole.isEmpty()) {
          continue;
        }
        holes.add(hole);
      }
      return this._factory.createPolygon(shell, holes.toArray([]));
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return GeometryEditor;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { GeometryEditor as default };
function GeometryEditorOperation() {}
GeometryEditor.GeometryEditorOperation = GeometryEditorOperation;
var NoOpGeometryOperation = /*#__PURE__*/function () {
  function NoOpGeometryOperation() {
    _classCallCheck(this, NoOpGeometryOperation);
    NoOpGeometryOperation.constructor_.apply(this, arguments);
  }
  return _createClass(NoOpGeometryOperation, [{
    key: "edit",
    value: function edit(geometry, factory) {
      return geometry;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return NoOpGeometryOperation;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [GeometryEditorOperation];
    }
  }]);
}();
NoOpGeometryOperation.constructor_ = function () {};
var CoordinateOperation = /*#__PURE__*/function () {
  function CoordinateOperation() {
    _classCallCheck(this, CoordinateOperation);
    CoordinateOperation.constructor_.apply(this, arguments);
  }
  return _createClass(CoordinateOperation, [{
    key: "edit",
    value: function edit(geometry, factory) {
      var coordinates = this.edit(geometry.getCoordinates(), geometry);
      if (geometry instanceof LinearRing) {
        if (coordinates === null) return factory.createLinearRing();else return factory.createLinearRing(coordinates);
      }
      if (geometry instanceof LineString) {
        if (coordinates === null) return factory.createLineString();else return factory.createLineString(coordinates);
      }
      if (geometry instanceof Point) {
        if (coordinates === null || coordinates.length === 0) return factory.createPoint();else return factory.createPoint(coordinates[0]);
      }
      return geometry;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return CoordinateOperation;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [GeometryEditorOperation];
    }
  }]);
}();
CoordinateOperation.constructor_ = function () {};
var CoordinateSequenceOperation = /*#__PURE__*/function () {
  function CoordinateSequenceOperation() {
    _classCallCheck(this, CoordinateSequenceOperation);
    CoordinateSequenceOperation.constructor_.apply(this, arguments);
  }
  return _createClass(CoordinateSequenceOperation, [{
    key: "edit",
    value: function edit(geometry, factory) {
      if (geometry instanceof LinearRing) {
        return factory.createLinearRing(this.edit(geometry.getCoordinateSequence(), geometry));
      }
      if (geometry instanceof LineString) {
        return factory.createLineString(this.edit(geometry.getCoordinateSequence(), geometry));
      }
      if (geometry instanceof Point) {
        return factory.createPoint(this.edit(geometry.getCoordinateSequence(), geometry));
      }
      return geometry;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return CoordinateSequenceOperation;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [GeometryEditorOperation];
    }
  }]);
}();
CoordinateSequenceOperation.constructor_ = function () {};
GeometryEditor.NoOpGeometryOperation = NoOpGeometryOperation;
GeometryEditor.CoordinateOperation = CoordinateOperation;
GeometryEditor.CoordinateSequenceOperation = CoordinateSequenceOperation;
GeometryEditor.constructor_ = function () {
  this._factory = null;
  this._isUserDataCopied = false;
  if (arguments.length === 0) {} else if (arguments.length === 1) {
    var factory = arguments[0];
    this._factory = factory;
  }
};